import { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom'
import {sendPasswordResetLink} from '../../common/BackendConnections';
import classes from './AuthForm.module.css';


const ForgotPassword = () => {
  const emailInputRef = useRef();
  const navigate = useNavigate()
  const [message, setMessage] = useState("");
  const [emailInput, setEmailInput] = useState("Enter your email address...")

  const submitHandler = (event) => {
    event.preventDefault();
    const enteredEmail = emailInputRef.current.value;

    setMessage("");

    sendPasswordResetLink(enteredEmail).then((response) => {
      console.debug(response);
      setMessage(response.data.message)
      setEmailInput("")
        setTimeout(() => {
          navigate('/auth/')
        }, 3000)
    }
    ).catch((error) => {
      console.debug(error);
      setMessage(error.message);
    });
  };

  const handleEmailInput = (event) => {
    setEmailInput(event.target.value)
  }

  const handleCancel = () => {
    return navigate('/auth')
  }

  return (
    <section className={"page_content"} style={{marginTop: "15vh"}}>
      <div className={classes.forgotpassword}>
        <img className={classes.logo} src="/images/UNLTDTHERA_CONNECT_V2.png" alt="Unlimited therapy logo" />
        <h2 style={{fontWeight:'bold', marginTop: '2em'}}>Password Recovery</h2>
        <form onSubmit={submitHandler} style={{marginTop: '2em'}}>
          <div className={classes.control}>
            <label htmlFor='email'>Email Address</label>
            <input
              type='email'
              id='recoveryEmail'
              required
              ref={emailInputRef}
              autoComplete={"off"}
              placeholder={emailInput}
              onChange={handleEmailInput}
            />
          </div>
          <div>{message}</div>
          <div className={classes.actions}>
              <button className={"text-capitalize"}>Send Password Reset Link</button>
          </div>
        </form>
        <div className={classes.actions}>
          <button className={"text-capitalize"} onClick={handleCancel}>Cancel</button>
        </div>
      </div>
    </section>
  );
};

export default ForgotPassword;
